import Axios from 'axios'
import { stringify } from '@/utils/index'

// 声明一个 Map 用于存储每个请求的标识 和 取消函数
const pending = new Map()

/**
 * @description: 添加请求
 * @param {AxiosRequestConfig} config
 */
export const addPending = (config) => {
  const newParams = { ...config.params }
  const newData = { ...config.data }
  if (newParams.requestId) {
    delete newParams.requestId
  }
  if (newData.data) {
    delete newData.data
  }
  const url = [
    config.method,
    config.url,
    stringify(newParams),
    stringify(newData),
  ].join('&')
  config.cancelToken =
    config.cancelToken ||
    new Axios.CancelToken((cancelFn) => {
      if (!pending.has(url)) {
        // 如果 pending 中不存在当前请求，则添加进去
        pending.set(url, cancelFn) // 让请求的url和对应的取消请求方法一一对应，在需要时执行
      }
    })
}

/**
 * @description: 移除请求
 * @param {AxiosRequestConfig} config
 */
export const removePending = (config) => {
  const newParams = { ...config.params }
  const newData = { ...config.data }
  if (newParams.requestId) {
    delete newParams.requestId
  }
  if (newData.data) {
    delete newData.data
  }
  const url = [
    config.method,
    config.url,
    stringify(newParams),
    stringify(newData),
  ].join('&')
  if (pending.has(url)) {
    // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
    const cancel = pending.get(url)
    cancel(url)
    pending.delete(url)
  }
}

/**
 * @description: 清空 pending 中的请求（在路由跳转时调用）
 */
export const clearPending = () => {
  for (const [url, cancel] of pending) {
    cancel(url)
  }
  pending.clear()
}
